import { render } from "./PrivacyPage.vue?vue&type=template&id=82bdba28&scoped=true&ts=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPage.vue?vue&type=script&lang=ts"

import "./PrivacyPage.vue?vue&type=style&index=0&id=82bdba28&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bdba28"]])

export default __exports__